function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { safePrefix } from '../utils';
import Header from './Header';
import Subscribe from './Subscribe';
import Footer from './Footer';

var Body =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Body, _React$Component);

  function Body() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Body.prototype;

  _proto.render = function render() {
    return React.createElement(React.Fragment, null, React.createElement(Helmet, null, React.createElement("title", null, _.get(this.props, 'pageContext.frontmatter.title') && _.get(this.props, 'pageContext.frontmatter.title') + ' - ', _.get(this.props, 'pageContext.site.siteMetadata.title')), React.createElement("meta", {
      charSet: "utf-8"
    }), React.createElement("meta", {
      name: "viewport",
      content: "width=device-width, initialScale=1.0"
    }), React.createElement("meta", {
      name: "google",
      content: "notranslate"
    }), React.createElement("link", {
      href: "https://fonts.googleapis.com/css?family=PT+Sans:400,400i,700,700i%7CPT+Serif:400,700",
      rel: "stylesheet"
    }), React.createElement("link", {
      rel: "stylesheet",
      href: safePrefix('assets/css/main.css')
    }), _.get(this.props, 'pageContext.frontmatter.template') === 'post' && _.get(this.props, 'pageContext.frontmatter.canonical_url') && React.createElement("link", {
      rel: "canonical",
      href: _.get(this.props, 'pageContext.frontmatter.canonical_url')
    })), React.createElement("div", {
      id: "page",
      className: 'site layout-' + _.get(this.props, 'pageContext.site.siteMetadata.layout_style') + ' palette-' + _.get(this.props, 'pageContext.site.siteMetadata.palette')
    }, React.createElement(Header, this.props), React.createElement("div", {
      id: "content",
      className: "site-content"
    }, React.createElement("main", {
      id: "main",
      className: "site-main inner"
    }, this.props.children)), _.get(this.props, 'pageContext.site.data.subscribe.enabled') && React.createElement(Subscribe, this.props), React.createElement(Footer, this.props)));
  };

  return Body;
}(React.Component);

export { Body as default };